import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import ElfsightWidget from '../components/about/ElfsightWidget';
import SEOHead from '../components/SEOHead';
import LeadersHero from '../components/leaders/LeadersHero';
import LeadersInvitation from '../components/leaders/LeadersInvitation';
import LeadersContainer from '../components/leaders/LeadersContainer';
import InnerTerritory from '../components/leaders/InnerTerritory';
import LeadersThreshold from '../components/leaders/LeadersThreshold';

const Services = () => {
  const servicesJsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "Service",
      "serviceType": "Executive Coaching",
      "name": "1:1 Executive Coaching with ParadoxEdge",
      "provider": {
        "@type": "Organization",
        "name": "ParadoxEdge",
        "url": "https://www.paradoxedge.com"
      },
      "description":
        "A private 1:1 practice for senior leaders whose next level of impact asks for a different level of being.",
      "url": "https://www.paradoxedge.com/services",
      "areaServed": "Worldwide",
      "audience": { "@type": "BusinessAudience", "audienceType": "Senior executives and C-suite leaders" }
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What is executive coaching at ParadoxEdge?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "A private 1:1 practice for senior leaders whose next level of impact asks for a different level of being. Sustained, confidential engagements led personally by Kent Frazier, a former HR executive and Certified Integral Master Coach."
          }
        },
        {
          "@type": "Question",
          "name": "Who does ParadoxEdge work with?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Senior executives and C-suite leaders. Often those whose career playbook is expiring, who are navigating AI and complexity faster than their organization can absorb, and who are ready to develop the interior capacities their role now requires."
          }
        },
        {
          "@type": "Question",
          "name": "How is this different from typical executive coaching?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "The work is developmental, not performative. It grows judgment, presence, and the human depth required to lead in complexity, which we call vertical development, rather than optimizing surface behaviors."
          }
        },
        {
          "@type": "Question",
          "name": "How long does a coaching engagement last?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Engagements are sustained rather than short-term. Depth work compounds over months and years, not weeks. First conversations are exploratory and non-obligating."
          }
        },
        {
          "@type": "Question",
          "name": "Where is ParadoxEdge based, and do you work remotely?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "ParadoxEdge is based in Denver, Colorado and works with leaders globally. Engagements are conducted in person and remotely."
          }
        },
        {
          "@type": "Question",
          "name": "How do I begin?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Schedule a first conversation with Kent Frazier at https://calendly.com/kentfrazier/30-minutes. It is exploratory. A chance to see whether the practice is a fit for the moment you are in."
          }
        }
      ]
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.paradoxedge.com/" },
        { "@type": "ListItem", "position": 2, "name": "For Leaders", "item": "https://www.paradoxedge.com/services" }
      ]
    }
  ];

  return (
    <>
      <SEOHead
        title="For Leaders | Private 1:1 Executive Coaching | ParadoxEdge"
        description="A private 1:1 practice for senior leaders whose next level of impact asks for a different level of being."
        canonicalUrl="/services"
        keywords="executive coaching, 1:1 leadership coaching, private coaching, senior leadership development, inner work, presence-based coaching, vertical development"
        jsonLd={servicesJsonLd}
      />
      <div className="min-h-screen bg-background">
        <Navigation />
        <ElfsightWidget />

        <main>
          <LeadersHero />
          <LeadersInvitation />
          <LeadersContainer />
          <InnerTerritory />
          <LeadersThreshold />
        </main>

        <Footer />
      </div>
    </>
  );
};

export default Services;
